import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { auth, db } from "../firebase/client";
import type { CurrentUser } from "../types/auth.types";

export function useCurrentUser(): CurrentUser | null {
	const [user, setUser] = useState<CurrentUser | null>(null);

	useEffect(() => {
		return onAuthStateChanged(auth, (firebaseUser) => {
			if (!firebaseUser || firebaseUser.isAnonymous) {
				setUser(null);
				return;
			}

			return onSnapshot(doc(db, "users", firebaseUser.uid), (snap) => {
				const data = snap.data();
				setUser({
					uid: firebaseUser.uid,
					email: firebaseUser.email,
					name: data?.name ?? null,
					admin: data?.admin === true,
					blockedUsers: data?.blockedUsers ?? [],
				});
			});
		});
	}, []);

	return user;
}
